<template>
  <div class="myexam-card-container">
    <div class="grace-container">
      <div class="exam-title grace-exam-title">
        <el-tooltip
          class="item"
          :content="examtitle"
          effect="light"
          placement="top-start"
        >
          <div class="title-text">{{ examtitle }}</div>
        </el-tooltip>
      </div>
      <div class="grace-content" v-if="itemType == 'exam'">
        <div class="exam-time">
          <div>
            <span class="num-title">考试时间：</span>
            <span
              class="time-value"
            >{{ examInfo["exam_manage_goinglistdata.exam_date_time"] }}
            </span>
          </div>
        </div>
        <div class="exam-row">
          <el-row :span="12">
            <el-col
              :span="12"
            ><span class="num-title">考试时长：</span
            ><span
              v-if="examInfo['exam_manage_goinglistdata.exam_time']"
              class="grace-num-value"
            >{{ examInfo["exam_manage_goinglistdata.exam_time"] }}分钟</span
            >
            </el-col>
            <el-col
              :span="12"
            ><span class="num-title">考试总分：</span
            ><span class="grace-num-value">
              {{ examInfo["exam_manage_goinglistdata.total_score"] }}分</span
            >
            </el-col>
          </el-row>
          <el-row :span="12">
            <el-col
              :span="12"
            ><span class="num-title">及格分数：</span
            ><span class="grace-num-value">
              {{ examInfo["exam_manage_goinglistdata.pass_score"] }}分</span
            >
            </el-col>
            <el-col
              :span="12"
            ><span class="num-title">考试次数：</span
            ><span class="grace-num-value">
              {{ examInfo["exam_manage_goinglistdata.exam_num"] }}次</span
            >
            </el-col>
          </el-row>
          <el-row :span="12">
            <el-col
              :span="12"
            ><span class="num-title">已考次数：</span
            ><span class="grace-num-value">
              {{ examInfo["exam_manage_goinglistdata.last_num"] }}次</span
            >
            </el-col>
            <el-col
              :span="12"
            ><span class="num-title">剩余次数：</span
            ><span class="grace-num-value">
              {{ examInfo["exam_manage_goinglistdata.tested_num"] }}次</span
            >
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="grace-content" v-if="itemType == 'training'">
        <div class="exam-time">
          <div>
            <span class="num-title">练习时间：</span>

            <span
              class="time-value"
            >{{ examInfo["exam_training_doingdatalist.training_time"] }}
            </span>
          </div>
        </div>
        <div class="exam-row">
          <el-row :span="12">
            <el-col
              :span="12"
            ><span class="num-title">总题数：</span>
              <span
                class="grace-num-value"
              >{{ examInfo["exam_training_doingdatalist.num"] }}个</span
              ></el-col
            >
            <el-col
              :span="12"
            ><span class="num-title">单选题：</span>
              <span
                class="grace-num-value"
              >{{ examInfo["exam_training_doingdatalist.radio_num"] }}个</span
              ></el-col
            >
          </el-row>
          <el-row :span="12">
            <el-col
              :span="12"
            ><span class="num-title">多选题：</span>
              <span
                class="grace-num-value"
              >{{
                examInfo["exam_training_doingdatalist.checkbox_num"]
              }}个</span
              ></el-col
            >
            <el-col
              :span="12"
            ><span class="num-title">填空题：</span>
              <span
                class="grace-num-value"
              >{{ examInfo["exam_training_doingdatalist.input_num"] }}个</span
              ></el-col
            >
          </el-row>
          <el-row :span="12">
            <el-col
              :span="12"
            ><span class="num-title">判断题：</span>
              <span
                class="grace-num-value"
              >{{ examInfo["exam_training_doingdatalist.judge_num"] }}个</span
              ></el-col
            >
            <el-col
              :span="12"
            ><span class="num-title">练习次数：</span>
              <span
                class="grace-num-value"
              >{{ examInfo["exam_training_doingdatalist.last_num"] }}次</span
              ></el-col
            >
          </el-row>
        </div>
      </div>

      <div class="grace-exam-btnnav" v-if="itemType == 'exam'">
        <div class="grace-exam-button" type="plain" @click="getRules()">考生须知</div>
        <div
          class="grace-exam-button"
          @click="checkExam()"
          v-if="examInfo.isExist == '1'"
        >查看结果</div>
        <div
          class="grace-exam-button main-button"
          @click="continueExam()"
          v-if="
            examInfo['viewStatus'] == 2 &&
              examInfo['exam_manage_goinglistdata.exam_num'] != 0
          "
        >继续考试</div>

        <div
          :class="[
            'grace-exam-button',
            { 'main-button': examInfo['viewStatus'] == 1 },
          ]"
          v-if="
            (examInfo['viewStatus'] == 1 || examInfo['viewStatus'] == 4) &&
              examInfo['exam_manage_goinglistdata.tested_num'] != 0 &&
              queryString.type == '0'
          "
          @click="startExam()"
        >开始考试</div>

        <div class="grace-exam-button" v-if="examInfo['viewStatus'] == 3">未开始</div>

        <div
          class="grace-exam-button"
          v-if="examInfo['exam_manage_goinglistdata.exam_num'] <= 0"
          @click="openExamTips()"
        >提示</div>
      </div>

      <div class="grace-exam-btnnav" v-if="itemType == 'training'">
        <div
          class="grace-exam-button"
          :type="queryString.type == '0' ? 'plain' : ''"
          @click="checkTraining()"
          v-if="examInfo['exam_training_doingdatalist.last_num'] > 0 &&examInfo['exam_training_doingdatalist.num'] > 0"
        >查看练习</div>
        <!-- <div
          class="grace-exam-button main-button"
          @click="aginTraining()"
          v-if="
            examInfo['exam_training_doingdatalist.type'] == 3 &&
              examInfo['exam_training_doingdatalist.num'] > 0 &&
              canToTraining === true
          "
        >
          重新练习
        </div> -->
        <div
          class="grace-exam-button main-button"
          @click="continueTraining()"
          v-if="examInfo['exam_training_doingdatalist.type'] == 2 &&
            examInfo['exam_training_doingdatalist.num'] > 0 &&
            canToTraining === true"
        >继续练习</div>

        <div
          class="grace-exam-button main-button"
          v-if="examInfo['exam_training_doingdatalist.type'] == 1 && canToTraining === true"
          @click="startTraining()"
        >开始练习</div>
        <div
          class="grace-exam-button"
          v-if="showTips === true"
          @click="openTrainingTips()"
        >提示</div>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfCardGraceStyle",
  ctrlCaption: "优雅模式",
  mixins: [$mixins.control],
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      examInfo: {},
      examtitle: "",
      itemType: "",
    };
  },
  created() {
    if (this.isDesign) {
      this.itemType = "exam";
      this.examInfo = {
        "exam_manage_goinglistdata.batch_name": "第1批",
        "exam_manage_goinglistdata.exam_time": 90,
        "exam_manage_goinglistdata.exam_name": "期末考试",
        "exam_manage_goinglistdata.type": 3,
        "exam_manage_goinglistdata.exam_date_time":
          "2021-10-01 00:00 - 2021-11-30 00:00",
        "exam_manage_goinglistdata.exam_manage_id":
          "d07a9863d4594d0fbf441d6523cb976c",
        "exam_manage_goinglistdata.pass_score": 60.0,
        "exam_manage_goinglistdata.total_score": 100.0,
        "exam_manage_goinglistdata.exam_num": 5,
        "exam_manage_goinglistdata.tested_num": 4,
        "exam_manage_goinglistdata.last_num": 1,
      };
      this.examtitle = "期末考试 第1批";
    } else {
      this.examInfo = this.value;
      var keyNames = Object.keys(this.examInfo);
      if (keyNames.includes("exam_manage_goinglistdata.exam_name")) {
        //考试列表
        this.itemType = "exam";
        this.examtitle =
          this.examInfo["exam_manage_goinglistdata.exam_name"] +
          " " +
          this.examInfo["exam_manage_goinglistdata.batch_name"];
      } else if (keyNames.includes("exam_training_doingdatalist.name")) {
        this.itemType = "training";
        this.examtitle = this.examInfo["exam_training_doingdatalist.name"];
      }
    }
  },
  mounted() {
    // console.log(this.itemType);
  },
  computed: {
    //未开始考试
    showStartNo() {
      if (this.examInfo["exam_manage_goinglistdata.type"] == 3) {
        return true;
      } else {
        return false;
      }
    },

    //是否查看考试
    canCheck() {
      if (this.examInfo["exam_manage_goinglistdata.last_num"] > 0) {
        return true;
      } else {
        return false;
      }
    },

    //是否显示开始考试
    canExam() {
      // 不是继续考试 不是未开始考试  剩余次数大于0
      if (
        this.examInfo["exam_manage_goinglistdata.type"] != 2 &&
        this.examInfo["exam_manage_goinglistdata.type"] != 3 &&
        this.examInfo["exam_manage_goinglistdata.tested_num"] > 0
      ) {
        if (this.isDesign) {
          //设计模式
          return true;
        } else if (!this.isDesign && this.queryString.type == "0") {
          //当前考试
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    //能否练习
    canToTraining() {
      if (this.itemType == "training") {
        var numbers = this.examInfo["exam_training_doingdatalist.num"];
        if (
          this.examInfo["exam_training_doingdatalist.training_time"] &&
          this.examInfo["exam_training_doingdatalist.training_time"] != "不限时"
        ) {
          if (
            this.examInfo["exam_training_doingdatalist.type"] != 3 &&
            numbers != "0" &&
            this.queryString.type == "0"
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          if (numbers != "0") {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },

    //是否显示练习的提示按钮
    showTips() {
      var show = false;
      if (this.itemType == "training") {
        //练习题数量为0
        if (this.examInfo["exam_training_doingdatalist.num"] == "0") {
          show = true;
        }
        if (
          this.examInfo["exam_training_doingdatalist.training_time"] != "不限时"
        ) {
        //历史练习且练习题数量为0
          if (
            this.queryString.type == "1" &&
            this.examInfo["exam_training_doingdatalist.last_num"] <= "0"
          ) {
            show = true;
          }
          //未开始练习
          if (this.examInfo["exam_training_doingdatalist.type"] == 3) {
            show = true;
          }
        }
      }
      return show;
    },
  },
  methods: {
    openExamTips() {
      dsf.layer.alert("未设置考试次数。");
    },

    //继续考试
    continueExam() {
      var pathname = this.changeStr();
      this.$openWindow(
        pathname +
          "#/pc/exam/exam?recordId=" +
          this.examInfo.recordId +
          "&type=manage"
      );
    },

    //开始考试
    startExam() {
      var pathname = this.changeStr();
      if (this.examInfo.viewStatus != 4 && this.queryString.type == "0") {
        this.$openWindow(
          pathname +
            "#/pc/exam/manage/examinfo?batchId=" +
            this.examInfo._id +
            "&share=0"
        );
      }
    },

    //查看考试结果
    checkExam() {
      var pathname = this.changeStr();
      this.$openWindow(
        pathname +
          "#/pc/exam/check-exam-result?batchId=" +
          this.examInfo._id +
          "&manageId=" +
          this.examInfo["exam_manage_goinglistdata.exam_manage_id"]
      );
    },

    //考生须知
    getRules() {
      this.$openDialog({
        title: "考试须知",
        width: "700px",
        height: "650px",
        overflow: "auto",
        footerAlign: "center",
        params: {
          path: "exam/manage/examinfo?batchId=" + this.examInfo._id,
        },
        btns: [
          {
            text: "确定",
            handler: (res) => {
              res.$dialog.close();
            },
          },
        ],
      });
    },

    //练习提示
    openTrainingTips() {
      var tipsMessge = "";
      var numbers = this.examInfo["exam_training_doingdatalist.num"];
      if (numbers == "0") {
        tipsMessge = "该练习暂未添加试题，无法开启练习，请联系管理员添加试题。";
      }
      if (
        this.examInfo["exam_training_doingdatalist.training_time"] != "不限时"
      ) {
        if (this.examInfo["exam_training_doingdatalist.type"] == 3) {
          tipsMessge = "该练习暂未开始，请等待。";
        } else if (this.queryString.type == "1") {
          if (this.examInfo["exam_training_doingdatalist.last_num"] <= "0") {
            tipsMessge = "未参与练习，无法查看。";
          }
          if (numbers == "0") {
            tipsMessge = "该练习未添加试题，无法查看练习。";
          }
        }
      }

      dsf.layer.alert(tipsMessge);
    },

    //继续练习
    continueTraining() {
      var pathname = this.changeStr();
      var recordId = dsf.isDef(this.examInfo.recordId)
        ? this.examInfo.recordId
        : "";
      this.$openWindow(
        pathname +
          "#/pc/exam/exam-practice?id=" +
          this.examInfo._id +
          "&recordId=" +
          recordId
      );
    },

    //开始练习
    startTraining() {
      var pathname = this.changeStr();
      this.$openWindow(
        pathname + "#/pc/exam/exam-practice?id=" + this.examInfo._id
      );
    },

    //查看结果
    checkTraining() {
      var pathname = this.changeStr();
      this.$openWindow(
        pathname + "#/pc/exam/practice-result?trainingId=" + this.examInfo._id
      );
    },

    //重新练习
    aginTraining() {
      var pathname = this.changeStr();
      this.$openWindow(
        pathname + "#/pc/exam/exam-practice?id=" + this.examInfo._id
      );
    },

    //替换字符串
    changeStr() {
      var pathname = location.pathname;
      var arr = pathname.split("/");
      if (pathname.includes("index.html")) {
        arr.splice(arr.length - 1, 1);
        pathname = arr.join("/") + "/page.html";
      }
      return pathname;
    },
  },
});
</script>

<style></style>
